import React, { FC } from 'react';
import { Box } from '@mui/material';
import { Header } from '../../components/header';
import { Time, User, Help } from '../../components/header/components';
import LibraryAccordions from '../../components/software-library-management/library-accordions';
import useStyles from './styles';

const SoftwareLibraryManagement: FC = () => {
  const classes = useStyles();

  return (
    <Box>
      <Header title="Software Library Management"
        headerComponents={[<Help userLink='/SitePages/Software-Library-Management.aspx?promotedState=0'/>, <Time suppressPopover />, <User />]}
      />
      <Box className={classes.scrollBox}>
        <LibraryAccordions />
      </Box>
    </Box>
  );
};

export default SoftwareLibraryManagement;
